// Mock data for the prompt builder app

export const mockProjects = [
  {
    id: '1',
    name: 'Content Creation',
    description: 'Prompts for blog posts, social media, and marketing copy',
    createdAt: '2024-01-15',
    promptCount: 7
  },
  {
    id: '2', 
    name: 'Code Review',
    description: 'Technical prompts for code analysis and debugging',
    createdAt: '2024-01-20',
    promptCount: 4
  },
  {
    id: '3',
    name: 'Data Analysis',
    description: 'Prompts for data interpretation and insights',
    createdAt: '2024-01-25',
    promptCount: 3
  }
];

export const mockPrompts = {
  '1': [
    {
      id: 'p1',
      title: 'Blog Post Outline',
      content: 'Create a comprehensive blog post outline for [TOPIC]. Include introduction, main points, subheadings, and conclusion.',
      createdAt: '2024-01-15',
      updatedAt: '2024-01-16'
    },
    {
      id: 'p2',
      title: 'Social Media Caption',
      content: 'Write an engaging social media caption for [PLATFORM] about [TOPIC]. Make it compelling and include relevant hashtags.',
      createdAt: '2024-01-16',
      updatedAt: '2024-01-17'
    },
    {
      id: 'p3',
      title: 'Email Newsletter',
      content: 'Draft a professional email newsletter for [AUDIENCE] about [TOPIC]. Include subject line, greeting, main content, and call-to-action.',
      createdAt: '2024-01-17',
      updatedAt: '2024-01-18'
    },
    {
      id: 'p4',
      title: 'Product Description',
      content: 'Write a compelling product description for [PRODUCT]. Highlight key features, benefits, and unique selling points.',
      createdAt: '2024-01-18',
      updatedAt: '2024-01-19'
    }
  ],
  '2': [
    {
      id: 'p5',
      title: 'Code Review Checklist',
      content: 'Review this code for [LANGUAGE] and provide feedback on: 1) Code quality, 2) Performance, 3) Security, 4) Best practices',
      createdAt: '2024-01-20',
      updatedAt: '2024-01-21'
    },
    {
      id: 'p6',
      title: 'Bug Analysis',
      content: 'Analyze this bug report and provide: 1) Root cause analysis, 2) Steps to reproduce, 3) Potential fixes, 4) Prevention strategies',
      createdAt: '2024-01-21',
      updatedAt: '2024-01-22'
    }
  ],
  '3': [
    {
      id: 'p7',
      title: 'Data Insights',
      content: 'Analyze this dataset and provide key insights, trends, and actionable recommendations for business decision making.',
      createdAt: '2024-01-25',
      updatedAt: '2024-01-26'
    }
  ]
};

export const mockSystemPrompts = [
  {
    id: 'default',
    name: 'Default Prompt Improver',
    content: 'You are an expert prompt engineer. Your task is to improve the given prompt by making it clearer, more specific, and more effective. Focus on:\n\n1. Clarity: Make instructions unambiguous\n2. Specificity: Add relevant details and context\n3. Structure: Organize the prompt logically\n4. Actionability: Ensure the prompt leads to useful outputs\n\nImprove the following prompt while maintaining its original intent:',
    isDefault: true,
    createdAt: '2024-01-01'
  },
  {
    id: 'creative',
    name: 'Creative Enhancement',
    content: 'You are a creative writing coach specializing in prompt optimization. Enhance the given prompt to unlock more creative and engaging responses. Focus on:\n\n1. Adding creative constraints that spark innovation\n2. Including sensory details and vivid imagery\n3. Encouraging unique perspectives and approaches\n4. Balancing structure with creative freedom\n\nTransform this prompt into a more creative and inspiring version:',
    isDefault: false,
    createdAt: '2024-01-10'
  },
  {
    id: 'technical',
    name: 'Technical Precision',
    content: 'You are a technical writing specialist. Optimize the given prompt for technical accuracy and precision. Focus on:\n\n1. Technical terminology and accuracy\n2. Step-by-step logical flow\n3. Specific requirements and constraints\n4. Measurable outcomes and criteria\n\nRefine this prompt for maximum technical clarity and precision:',
    isDefault: false,
    createdAt: '2024-01-12'
  }
];

export const mockSettings = {
  openRouterApiKey: '',
  selectedModel: 'anthropic/claude-3-haiku',
  defaultSystemPrompt: 'default'
};

export const mockModels = [
  {
    id: 'anthropic/claude-3-haiku',
    name: 'Claude 3 Haiku',
    provider: 'Anthropic',
    free: false,
    pricing: '$0.25/1M tokens'
  },
  {
    id: 'anthropic/claude-3-sonnet',
    name: 'Claude 3 Sonnet', 
    provider: 'Anthropic',
    free: false,
    pricing: '$3/1M tokens'
  },
  {
    id: 'openai/gpt-4o-mini',
    name: 'GPT-4o Mini',
    provider: 'OpenAI',
    free: false,
    pricing: '$0.15/1M tokens'
  },
  {
    id: 'openai/gpt-4o',
    name: 'GPT-4o',
    provider: 'OpenAI', 
    free: false,
    pricing: '$5/1M tokens'
  },
  {
    id: 'google/gemini-flash-1.5',
    name: 'Gemini 1.5 Flash',
    provider: 'Google',
    free: true,
    pricing: 'Free tier available'
  },
  {
    id: 'meta-llama/llama-3.1-8b-instruct:free',
    name: 'Llama 3.1 8B',
    provider: 'Meta',
    free: true,
    pricing: 'Free'
  }
];